export default __webpack_public_path__ + "static/media/The-Rogers-Foundation-color-logo (1).d5141895.png";